import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pickupInformation: {
    description: 'orderDrawer.pickupInformation.pickupInformation',
    defaultMessage: 'Pickup Information',
    id: 'mRM+Oz',
  },
});
